import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=71a8d8d0&scoped=true&"
import script from "./Connection.vue?vue&type=script&lang=ts&"
export * from "./Connection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8d8d0",
  null
  
)

export default component.exports